import { cssTheme } from '@uds/theme-utils';
import { WubLoader } from '@uds/penders';

import { loader } from './Loader.stylesheet';

export default function Loader(): JSX.Element {
  return (
    <div className={loader}>
      <WubLoader color={cssTheme.palette.primary} />
    </div>
  );
}
